var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedGoodsReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M26.1652 9.44814L16.7366 4.18787C16.5402 4.04697 16.2455 4 16 4C15.7054 4 15.4107 4.04697 15.2143 4.18787L5.78571 9.44814C5.29464 9.68297 5 10.1996 5 10.7632V17C5 17 6 16.5 6.5 16.5C7 16.5 7.35714 16.0938 7.35714 16.0938C7.35714 16.6574 12.0089 19.7652 12.5 20L10.5 25L15.2143 27.8121C15.4107 27.953 15.7054 28 15.9509 28C16.2455 28 16.5402 27.953 16.7366 27.8121L26.1652 22.5519C26.6562 22.317 27 21.8004 27 21.2368V10.7632C27 10.1996 26.6562 9.68297 26.1652 9.44814ZM16 6.34834L23.4643 10.5284L16 14.7084L8.48661 10.5284L16 6.34834ZM7.35714 12.501L14.8214 16.6341V24.9941L12 23.5V19C12 19 11.6136 17.6213 11 17C9.96993 15.9569 7.35714 16.0938 7.35714 16.0938V12.501ZM17.1786 24.9941V16.6341L24.6429 12.501V20.8141L17.1786 24.9941Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21C13 23.7614 10.7614 26 8 26C5.23858 26 3 23.7614 3 21C3 18.2386 5.23858 16 8 16C10.7614 16 13 18.2386 13 21Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F15A29",
    d: "M8 24.7474C5.91667 24.7474 4.25 23.0772 4.25 20.9895C4.25 18.9279 5.91667 17.2316 8 17.2316C10.0573 17.2316 11.75 18.9279 11.75 20.9895C11.75 23.0772 10.0573 24.7474 8 24.7474ZM9.66667 19.3976C9.58854 19.3193 9.45833 19.3193 9.38021 19.3976L7.55729 21.1983L6.77604 20.3893C6.69792 20.311 6.56771 20.311 6.48958 20.3893L5.99479 20.8851C5.91667 20.9634 5.91667 21.0939 5.99479 21.1722L7.40104 22.6075C7.47917 22.6858 7.60938 22.6858 7.6875 22.6075L10.1615 20.1805C10.2396 20.1022 10.2396 19.9717 10.1615 19.8673L9.66667 19.3976Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedGoodsReceipt);
export default __webpack_public_path__ + "static/media/Selected Goods Receipt.dcb246ce34b4031a524d382a58d9e3c5.svg";
export { ForwardRef as ReactComponent };